import ModalContentWrapper from "root/Modals/ModalContentWrapper";
import { Fragment } from "react";
import React from 'react';
import './ModalGoogleAccountProvision.scss';
import {provisionNewGoogleAccount} from "root/DataFunctions/GoogleFns";

const ModalGoogleAccountProvision = ({onSaveCompleted, onClose, mode, width = '600px'}) =>
{

    const provisionGoogleAccount = () =>
    {
        provisionNewGoogleAccount((response) =>
        {
            onSaveCompleted(response);
        })
    }

    const formContent = () =>
    {
        return (
            <div className="google-provision-content">
                <p>A Google account gives you access to School360's Google Workspace tools, including Gmail, Drive, Docs and Classroom, all signed in with your school identity.</p>
                <p>Your account will be created using your school email address. Once it's ready you'll
                    be able to sign in via School360.</p>
                <p>This usually takes a few moments. You'll only need to do this once.</p>
                <div className="google-provision-buttons">
                    <button className="btn btn-secondary btn-space-right" onClick={() => onClose()}>Cancel</button>
                    <button className="btn btn-primary btn-space-right" onClick={() => provisionGoogleAccount()}>Create</button>
                </div>
            </div>
        )
    }

    const headerStyle = {marginBottom: '10px'};

    const pageTitle = 'Provision your Google Account'

    return (
        <ModalContentWrapper className="modal-google-provision" width={'700px'} columns={1}>
            <Fragment>
                <h3 style={headerStyle}>{pageTitle}</h3>
                {formContent()}
            </Fragment>
        </ModalContentWrapper>
    )
}

export default ModalGoogleAccountProvision;